import { lazy } from 'react';

export const AcademicStaffPage = lazy(() => import('./AcademicStaffPage'));
